import Cookies from 'js-cookie'
export function getPublicKey() {
    return Cookies.get('tbb_key')
}
export function setPublicKey(tbb_key) {
    return Cookies.set('tbb_key', tbb_key)
}
export function removePublicKey() {
    return Cookies.remove('tbb_key')
}

export function getAesKey() {
    return Cookies.get('BAIDUAES')
}
export function setAesKey(BAIDUAES) {
    return Cookies.set('BAIDUAES', BAIDUAES)
}